// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".years-input--aBk8C{width:140px;margin-right:20px}.years-label--536kX{font-weight:500;display:flex;margin-bottom:10px}", "",{"version":3,"sources":["webpack://./src/pages/ContractDetails/ContractLines/components/CustomBillingInterval/custom-billing-interval.module.scss"],"names":[],"mappings":"AAAA,oBACE,WAAA,CACA,iBAAA,CAGF,oBACE,eAAA,CACA,YAAA,CACA,kBAAA","sourcesContent":[".years-input {\n  width: 140px;\n  margin-right: 20px;\n}\n\n.years-label {\n  font-weight: 500;\n  display: flex;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"years-input": "years-input--aBk8C",
	"years-label": "years-label--536kX"
};
export default ___CSS_LOADER_EXPORT___;
